'use strict';
const angular = require('angular');
const _ = require('lodash');
import { Ids as ACTION_IDS } from '../../components/constants/action.constants';

/**
 * The Util service is for thin, globally reusable, utility functions
 */
export function UtilService($window, $http, localStorage, $rootScope, config, $uibModal, $timeout, $httpParamSerializer) {
  'ngInject';
  let languageSpecificDateFormat = { "en_GB": "dd-M-yy", "fr_FR": "d M yy", "es_ES": "dd-M-yy", "ru_RU": "dd.mm.yy", "en_AU": "dd/mm/yy", "en_CA": "d-M-yy", "en_US": "M d, yy", "zh_CN": "yy-m-d", "de_DE": "dd.mm.yy", "ga_IE": "d M yy", "en_ZA": "dd M yy", "ja_JP": "yy/mm/dd", "ar_SA": "dd/mm/yy", "en_IE": "dd-M-yy", "it_IT": "dd/mm/yy" };
  var _ticksTo1970 = (((1970 - 1) * 365 + Math.floor(1970 / 4) - Math.floor(1970 / 100) + Math.floor(1970 / 400)) * 24 * 60 * 60 * 10000000);
  var loginModal;
  var timer;
  var Util = {
    controlsWithoutFieldName: ['Line'],
    /**
     * Return a callback or noop function
     *
     * @param  {Function|*} cb - a 'potential' function
     * @return {Function}
     */
    safeCb(cb) {
      return (angular.isFunction(cb)) ? cb : angular.noop;
    },

    /**
     * Parse a given url with the use of an anchor element
     *
     * @param  {String} url - the url to parse
     * @return {Object}     - the parsed url, anchor element
     */
    urlParse(url) {
      var a = document.createElement('a');
      a.href = url;

      // Special treatment for IE, see http://stackoverflow.com/a/13405933 for details
      if (a.host === '') {
        a.href = a.href;
      }

      return a;
    },

    /**
     * Test whether or not a given url is same origin
     *
     * @param  {String}           url       - url to test
     * @param  {String|String[]}  [origins] - additional origins to test against
     * @return {Boolean}                    - true if url is same origin
     */
    isSameOrigin(url, origins) {
      url = Util.urlParse(url);
      origins = (origins && [].concat(origins)) || [];
      origins = origins.map(Util.urlParse);
      origins.push($window.location);
      origins = origins.filter(function (o) {
        let hostnameCheck = url.hostname === o.hostname;
        let protocolCheck = url.protocol === o.protocol;
        // 2nd part of the special treatment for IE fix (see above):
        // This part is when using well-known ports 80 or 443 with IE,
        // when $window.location.port==='' instead of the real port number.
        // Probably the same cause as this IE bug: https://goo.gl/J9hRta
        let portCheck = url.port === o.port || (o.port === '' && (url.port === '80' || url.port === '443'));
        return hostnameCheck && protocolCheck && portCheck;
      });
      return origins.length >= 1;
    },

    accessTableElements(list, callback) {
      let rows = list.data;
      if (rows.length) {
        for (let j = 0; j < rows.length; j++) {
          let columns = rows[j];
          if (columns.length) {
            for (let k = 0; k < columns.length; k++) {
              let elems = columns[k].elems[0];
              if (elems.length) {
                callback(elems)
              }
            }
          }
        }
      }
    },

    accessLayoutElements(list, callback) {
      let data = list.data;
      if (data.length) {
        for (let j = 0; j < data.length; j++) {
          let elems = data[j].elems[0];
          if (elems.length) {
            callback(elems);
          }
        }
      }
    },

    accessRepeatingTableElements(list, callback, excludeRepeatData) {
      let columns = list.data[0];
      if (columns.length && !excludeRepeatData) {
        for (let k = 0; k < columns.length; k++) {
          let elems = columns[k].elems[0];
          if (elems.length) {
            callback(elems);
          }
        }
      }
      let headerColumns = list.header_data[0];
      if (headerColumns.length) {
        for (let k = 0; k < headerColumns.length; k++) {
          let elems = headerColumns[k].elems[0];
          if (elems.length) {
            callback(elems);
          }
        }
      }
      let footerColumns = list.footer_data[0];
      if (footerColumns.length) {
        for (let k = 0; k < footerColumns.length; k++) {
          let elems = footerColumns[k].elems[0];
          if (elems.length) {
            callback(elems);
          }
        }
      }
    },
    accessSectionElements(list, callback) {
      let elems = list.data.elems[0];
      if (elems.length) {
        callback(elems);
      }
    },

     recursionForRepeatingTable (data, name, callback, stopOnMatch) {
      let self = this;
      for (var key in data) {
          if (data.hasOwnProperty(key)) {
              var element = data[key];
              if (element.type === "RepeatingTable" &&  element.data.length > 0 && !element.derivedFromFieldName) {
                for (var j = 0; j < element.data.length; j++) {
                    var ev = element.data[0][0].elems[0][0];
                   
                    let fieldName = ev.properties['Basic']['Field Name'].selectedValue;
                    if (ev && fieldName == name ) {
                        callback(element.data, element);
                        if (stopOnMatch) {
                            return true;
                        }
                    }
                    else if (ev) {
                        self.recursionForRepeatingTable(ev, name, callback, stopOnMatch);
                    }
                }
            }
          }
      }
  },

    getIteams(list, finalArray = [], parent = '', excludeRepeatData = false, parentFieldName = '') {
      let self = this;
      let fieldName;
      if (list.length) {
        for (let i = 0; i < list.length; i++) {
          (parent || parent=='') && (list[i].parent = parent);
          parentFieldName && (list[i].parentFieldName = parentFieldName);
          fieldName = list[i].properties.Basic && list[i].properties.Basic['Field Name'].selectedValue;
          finalArray.push(list[i]);
          if (list[i].type == "Layout") {
            this.accessLayoutElements(list[i], function (elems) {
              self.getIteams(elems, finalArray, parent, excludeRepeatData);
            });
          }
          if (list[i].type == "Table") {
            this.accessTableElements(list[i], function (elems) {
              self.getIteams(elems, finalArray, parent, excludeRepeatData);
            });
          }
          if (list[i].type == "RepeatingTable") {
            this.accessRepeatingTableElements(list[i], function (elems) {
              self.getIteams(elems, finalArray, 'repeating-table', excludeRepeatData, fieldName);
            }, excludeRepeatData);
          }
          if (list[i].type == "Section") {
            this.accessSectionElements(list[i], function (elems) {
              self.getIteams(elems, finalArray, 'section');
            });
          }
        }
      }
      return finalArray;
    },

    getIteamsByType(list, finalArray = [], type, parent = '', parentFieldName = '') {
      let self = this;
      let fieldName;
      if (list.length) {
        for (let i = 0; i < list.length; i++) {
          parent && (list[i].parent = parent);
          parentFieldName && (list[i].parentFieldName = parentFieldName);
          fieldName = list[i].properties.Basic && list[i].properties.Basic['Field Name'].selectedValue;
          if (type.indexOf(list[i].type) != -1) {
            finalArray.push(list[i]);
          }
          if (list[i].type == "Table") {
            this.accessTableElements(list[i], function (elems) {
              self.getIteamsByType(elems, finalArray, type);
            });
          }
          /*if (list[i].type == "Section") {
            this.accessSectionElements(list[i], function (elems) {
              self.getIteamsByType(elems, finalArray, type);
            });
          }*/
          if (list[i].type == "Layout") {
            this.accessLayoutElements(list[i], function (elems) {
              self.getIteamsByType(elems, finalArray, type);
            });
          }
          if (list[i].type == "RepeatingTable") {
            this.accessRepeatingTableElements(list[i], function (elems) {
              self.getIteamsByType(elems, finalArray, type, 'repeating-table', fieldName);
            });
          }
        }
      }
      return finalArray;
    },

    returnSelected(list) {
      let controls = this.getIteams(list);
      return controls.filter(function (item) {
        return item.selected && item.selected == true;
      });
    },

    returnSelectedForCopy(list, finalArray = [], includeSubItems = true, copyAll = false) {
      let self = this;
      if (list.length) {
        for (let i = 0; i < list.length; i++) {
          if (list[i].selected || copyAll) {
            finalArray.push(list[i]);
          }
          if (list[i].type == "Layout" && !list[i].selected && includeSubItems) {
            this.accessLayoutElements(list[i], function (elems) {
              self.returnSelectedForCopy(elems, finalArray, includeSubItems);
            });
          }
          if (list[i].type == "Table" && !list[i].selected && includeSubItems) {
            this.accessTableElements(list[i], function (elems) {
              self.returnSelectedForCopy(elems, finalArray, includeSubItems);
            });
          }
          if (list[i].type == "RepeatingTable" && !list[i].selected && includeSubItems) {
            this.accessRepeatingTableElements(list[i], function (elems) {
              self.returnSelectedForCopy(elems, finalArray, includeSubItems);
            });
          }
          if (list[i].type == "Section" && !list[i].selected && includeSubItems) {
            this.accessSectionElements(list[i], function (elems) {
              self.returnSelectedForCopy(elems, finalArray, includeSubItems);
            });
          }
        }
      }
      return finalArray;
    },

    getProjectCustomAttributeSet(projectId) {
      $http({
        'url': (<any>window).properties.service.commonApiUrl + 'manageAttribute/getProjectCustomAttributeSet',
        'method': 'POST',
        'withCredentials': true,
        'data': $httpParamSerializer({ projectId: projectId, isRequiredHierarchyAttributes: 'true', callingArea: 'form'}),
        'headers': {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        if (response.data) {
          let data = response.data;
          $rootScope.ProjectCustomAttributeSet = data;
        } else {
          $rootScope.ProjectCustomAttributeSet = {};
        }
      }, err => {
        console.log("Error occuring during API call!");
      });
    },

    /**
     * Replace all matches with new string value
     * @param message - Message string
     * @param curText - Current text which will be replaces with new text
     * @param newText - New text
     * @return {String} message - New message in which new text with repalce with currrent text
     */
    replaceAllMatches(message, curText, newText) {
      while (message.indexOf(curText) != -1) {
          message = message.replace(curText, newText);
      }
      return message;
    },

    replaceUnderscoresValue(value) {
      if(value && typeof value == 'string' && value.indexOf('___') != -1) {
        return value.replace(/___+/g, '__');
      }
      return value;
    },

    getUSP() {
      let self = this;
      return new Promise(function (resolve, reject) {
        $http({
          'url': (<any>window).properties.service.uri + ACTION_IDS.GET_USP,
          'method': 'GET',
          'data': {},
          'headers': {
            'Content-Type': 'application/json;charset=UTF-8'
          },
          'withCredentials': true
        }).then(response => {
          if (response.data && response.data.entity) {
            let data = response.data.entity;
            $rootScope.USP = data;
          } else {
            $rootScope.USP = {};
          }
          resolve();
        }, (response) => {
          console.log(response);
          reject();
        });
      });
    },

    getAvailableDSFromServer() {
      let self = this;
      $http({
        'url': (<any>window).properties.service.uri + ACTION_IDS.GET_AVAILABLE_SECONDARY_DS,
        'method': 'GET',
        'data': {},
        'headers': {
          'Content-Type': 'application/json;charset=UTF-8'
        },
        'withCredentials': true
      }).then(response => {
        if (response.data && response.data.entity && response.data.entity.length) {
          self.availableDS = response.data.entity;
        }
      }, (response) => {
        console.log(response);
      });
    },

    getFixedFieldsFromServer() {
      let self = this;
      return new Promise(function (resolve, reject) {
        $http({
          'url': (<any>window).properties.service.uri + ACTION_IDS.GET_APPS_LOOKUP_DATA,
          'method': 'GET',
          'data': {},
          'headers': {
            'Content-Type': 'application/json;charset=UTF-8'
          },
          'withCredentials': true
        }).then(response => {
          if (response.data && response.data.entity) {
            self.multiValueFixedFields = response.data.entity.multiValueFixedFields;
            self.singleValueFixedFields = response.data.entity.singleValueFixedFields;
            self.singleValueFixedFields.push({
              name: "DS_locationName_PF",
              value: "Location Name",
              description: "Returns form location details"
            });
            self.singleValueFixedFields.push({
              name: "DS_locationPath_PF",
              value: "Location Path",
              description: "Returns form location details"
            });
            let item = self.multiValueFixedFields.filter((item) => item.name === "DS_INCOMPLETE_ACTIONS_BYMSG" || item.name === "DS_INCOMPLETE_ACTIONS").map((item) => JSON.parse(JSON.stringify(item)));
            if(item) {
              self.singleValueFixedFields.push(...item); 
            }
            self.viewNames = response.data.entity.views;
          }
          resolve(response);
        }, (response) => {
          console.log(response);
          resolve();
        });
      });
    },

    getValueOfOnLoadData(id) {
      let element: any = document.getElementById(id);
			if (!element) {
        return;
      }
      
      let val: any = '';
      if (element.value == '') {
				return val;
      }

			val = element.value;
			try {
        val = JSON.parse(val).Items.Item;
        if (val.length == 1 && !val[0].Name && !val[0].Value) {
          return [];
        }
        return val;
			} catch (e) {
				return val;
      }
		},

    getAvailableDS() {
      let options = [];
      if (this.availableDS && this.availableDS.length) {
        for (let i = 0; i < this.availableDS.length; i++) {
          options.push({
            key: this.availableDS[i].name,
            value: this.availableDS[i].uri + '/' + this.availableDS[i].name
          });
        }
      }
      return options;
    },

    getFixedFields(singleValue) {
      let availableFF = singleValue ? this.singleValueFixedFields : this.multiValueFixedFields;
      let options = [];
      if (availableFF.length) {
        for (var i = 0; i < availableFF.length; i++) {
          options.push({
            key: availableFF[i].value,
            value: availableFF[i].name == 'DS_WORKINGUSERROLE' ? 'DS_WORKINGUSER_ALL_ROLES' : availableFF[i].name,
            group: 'System'
          });
        }
      }
      return options;
    },

    getViewNames() {
      let viewNames = this.viewNames;
      let options = [];
      if (viewNames && viewNames.length) {
        for (var i = 0; i < viewNames.length; i++) {
          let element = viewNames[i];
          options.push({
            key: element.value,
            value: element.name
          });
        }
      }
      return options;
    },
    getCurrentFormViewNames() {
      let views = localStorage.get('views');
      let output:any = [];
      for (let viewName in views) {
        let found = this.viewNames.find(obj => obj.name === viewName);
        if (found) {
          output.push({
            name:found.value,
            value:found.name
          });
        } else {
          output.push({
            name:viewName,
            value:viewName
          });
        }
      }
      return output;
    },
    getProtectedParamsFromServer() {
      let self = this;
      return new Promise(function (resolve, reject) {
        $http({
          'url': (<any>window).properties.service.uri + ACTION_IDS.GET_PROTECTED_PARAMS,
          'method': 'GET',
          'data': {},
          'headers': {
            'Content-Type': 'application/json;charset=UTF-8'
          },
          'withCredentials': true
        }).then(response => {
          if (response.data && response.data.entity) {
            self.protectedParams = Object.keys(response.data.entity.entity || {}).map(elm => {return elm.toLowerCase();}) || [];
          }
          resolve(response);
        }, (response) => {
          console.log(response);
          resolve();
        });
      });
    },

    getProtectedParams() {
      return this.protectedParams;
    },

    getCustomAttributesFromServer(config) {
      let self = this;
      return new Promise(function (resolve, reject) {
        let projectId = _.get(config, 'formDetail.id.projectId', '');
        if (!projectId) {
          resolve();
          return
        }
        $http({
          'url': `${(<any>window).properties.service.commonApiUrl}${ACTION_IDS.GET_CUSTOM_ATTR_NAMES}?projectId=${projectId}`,
          'method': 'GET',
          'data': {},
          'headers': {
            'Content-Type': 'application/json;charset=UTF-8'
          },
          'withCredentials': true
        }).then(response => {
			self.customAttributes = response.data || [];
          resolve(response);
        }, (response) => {
          console.log(response);
          resolve();
        });
      });
    },

    getCustomAttributes() {
      let availableCA = this.customAttributes || [];
      let options = [];
      if (availableCA.length) {
        for (var i = 0; i < availableCA.length; i++) {
          options.push({
            key: availableCA[i],
            value: availableCA[i]
          });
        }
      }
      return options;
    },

    initServerCalls(config) {
      let self = this;
      if (this.initialized)
        return Promise.all([]);
      this.initialized = true;
      //this.getAvailableDSFromServer();
      let USP = this.getUSP();
      return USP.then(function () {
        return Promise.all([self.getFixedFieldsFromServer(), self.getSupportedLanguages(), self.getProtectedParamsFromServer(), self.getCustomAttributesFromServer(config), self.getDocColumnList(), self.getAppColumnList()]);
      });
    },

    getAllControls(excludeRepeatingTableVal = false) {
      let views = localStorage.get('views');
      let totalItems = [];
      for (let view in views) {
        totalItems = totalItems.concat(this.getIteams(views[view].controls.A, [], '', excludeRepeatingTableVal));
      }
      return totalItems;
    },

    getControlsByType(type) {
      let views = localStorage.get('views');
      let totalItems = [];
      for (let view in views) {
        totalItems = totalItems.concat(this.getIteamsByType(views[view].controls.A, [], type));
      }
      return totalItems;
    },

    getFieldNames(controlType) {
      let totalItems = this.getAllControls();
      let fieldNames = [];
      if (totalItems.length) {
        for (let i = 0; i < totalItems.length; i++) {
          if ((!controlType || controlType == totalItems[i].type) && this.controlsWithoutFieldName.indexOf(totalItems[i].type) == -1 && totalItems[i].properties.Basic && totalItems[i].properties.Basic['Field Name']) {
            let fieldName = totalItems[i].properties.Basic && totalItems[i].properties.Basic['Field Name'].selectedValue;
            let copiedReadonlyField = totalItems[i].copiedFrom ? true : false;
            let type = totalItems[i].properties.Basic.ControlType || '';
            let parent = totalItems[i].parent || '';
            if(type) {
              fieldName = fieldName + '$$' + type + '$$' + parent;
            }
            fieldName && !copiedReadonlyField && fieldNames.indexOf(fieldName) == -1 && fieldNames.push(fieldName);
          }
        }
      }
      return fieldNames.map(function (val) { 
        let fieldName = val.split('$$')[0];
        let typeName = val.split('$$')[1] || '';
        let parentName = val.split('$$')[2] || '';
        return { key: fieldName, value: fieldName, type: typeName, parent: parentName, group: 'Custom' } 
      });
    },
    getDataFieldNames(excludeRepeatingTableVal) {
      let totalItems = this.getAllControls(excludeRepeatingTableVal);
      let fieldNames = [];
      if (totalItems.length) {
        let onlyFieldNames = [];
        for (let i = 0; i < totalItems.length; i++) {
          if (this.controlsWithoutFieldName.indexOf(totalItems[i].type) == -1 && totalItems[i].properties.Basic && totalItems[i].properties.Basic['Data Field Name']) {
            if (totalItems[i].type == "InlineAssocFiles" || totalItems[i].type == "InlineAssocApps" || totalItems[i].type == "ViewAssociations") {
              continue;
            }
            let fieldName = totalItems[i].properties.Basic && totalItems[i].properties.Basic['Data Field Name'].selectedValue;
            if(fieldName && onlyFieldNames.indexOf(fieldName) == -1) {
              onlyFieldNames.push(fieldName);

              let type = totalItems[i].properties.Basic.ControlType || '';
              let parent = totalItems[i].parent || '';
              let parentFieldName = totalItems[i].parentFieldName || '';
              let dateWithTime = totalItems[i].properties.Basic.Time && totalItems[i].properties.Basic.Time['selectedValue'] || "";
              fieldName = fieldName + '$$' + type + '$$' + parent + '$$' + parentFieldName + '$$' + dateWithTime;
              fieldNames.push(fieldName);
            }
          }
        }
      }
      return fieldNames.map(function (val) { 
        let fieldName = val.split('$$')[0];
        let typeName = val.split('$$')[1] || '';
        let parentName = val.split('$$')[2] || '';
        let parentFieldName = val.split('$$')[3] || '';
        let isTimeEnabled = val.split('$$')[4] || '';
        return { key: fieldName, value: fieldName, type: typeName, parent: parentName, group: 'Custom', parentFieldName: parentFieldName, isTimeEnabled}
      });
    },
    getNumberFieldNames() {      
      let totalItems = this.getAllControls();
      let fieldNames = [];
      let totalNumOptions = [] ;
      let selectedType = [];
      let selectedParent = [];
      
      for (let totalItem in totalItems) {
        if((totalItems[totalItem].type.toLowerCase() == "textbox" &&
          totalItems[totalItem].properties.Basic.Validate.selectedValue != "" && 
          (totalItems[totalItem].properties.Basic.Validate.selectedValue == "Integer" || 
          totalItems[totalItem].properties.Basic.Validate.selectedValue == "Decimal") || 
          totalItems[totalItem].type.toLowerCase() == "display field" && 
          !totalItems[totalItem].properties.Basic.Label.isSelected)){
          totalNumOptions.push(totalItems[totalItem])
        }
       }
      
      if (totalNumOptions.length) {
        for (let i = 0; i < totalNumOptions.length; i++) {
          let fieldName = totalNumOptions[i].properties.Basic && totalNumOptions[i].properties.Basic['Field Name'] && totalNumOptions[i].properties.Basic['Field Name'].selectedValue;
          if(totalNumOptions[i].type.toLowerCase() == "textbox")
          selectedType.push(totalNumOptions[i].properties.Basic.Validate.selectedValue)
          fieldName && fieldNames.indexOf(fieldName) == -1 && fieldNames.push(fieldName);

          if(totalNumOptions[i].parent && totalNumOptions[i].parent == "repeating-table" && (totalNumOptions[i].type.toLowerCase() == "textbox" || totalNumOptions[i].type.toLowerCase() == "display field"))
          selectedParent.push(1)
          else
          selectedParent.push(0);

        }
      }
      return fieldNames.map(function (val,key) { return { key: val, value: val, type:selectedType[key], parent:selectedParent[key] } });
    },
    replaceFieldNameInCodeEditor(controls, oldFieldName, newFieldName) {
      if(!controls) {
        controls = this.getAllControls();
      }

      //Replace in controls events code editor
      controls.forEach((control) => {
        if(control.properties && control.properties.Events) {
          for(let event in control.properties.Events) {
            let eventDetail = control.properties.Events[event];
            if(event != 'Name' && event != 'forceToDisabled' && eventDetail.selectedValue) {
              eventDetail.selectedValue = this.replaceAllMatches(eventDetail.selectedValue, "PropValue('"+ oldFieldName+"'", "PropValue('"+ newFieldName+"'");
              eventDetail.selectedValue = this.replaceAllMatches(eventDetail.selectedValue, "resetRepeatingTableValue('"+ oldFieldName+"'", "resetRepeatingTableValue('"+ newFieldName+"'");
              eventDetail.selectedValue = this.replaceAllMatches(eventDetail.selectedValue, "getRepeatingTableValue('"+ oldFieldName+"'", "getRepeatingTableValue('"+ newFieldName+"'");
              eventDetail.xmlValue = this.replaceAllMatches(eventDetail.xmlValue, "<field name=\"CONTROL_NAME\">"+ oldFieldName+"</field><field name=\"PROPERTY_NAME\">", "<field name=\"CONTROL_NAME\">"+ newFieldName+"</field><field name=\"PROPERTY_NAME\">");
              eventDetail.xmlValue = this.replaceAllMatches(eventDetail.xmlValue, "<field name=\"CONTROL_NAME\">"+ oldFieldName+"</field></block>", "<field name=\"CONTROL_NAME\">"+ newFieldName+"</field></block>");
            }
          }
        }
      });

      //Replace in Globle code editor
      if(window['globle'].scriptVal) {
        window['globle'].scriptVal = this.replaceAllMatches(window['globle'].scriptVal, "PropValue('"+ oldFieldName+"'", "PropValue('"+ newFieldName+"'");
        window['globle'].scriptVal = this.replaceAllMatches(window['globle'].scriptVal, "resetRepeatingTableValue('"+ oldFieldName+"'", "resetRepeatingTableValue('"+ newFieldName+"'");
        window['globle'].scriptVal = this.replaceAllMatches(window['globle'].scriptVal, "getRepeatingTableValue('"+ oldFieldName+"'", "getRepeatingTableValue('"+ newFieldName+"'");
        window['globle'].xmlVal = this.replaceAllMatches(window['globle'].xmlVal, "<field name=\"CONTROL_NAME\">"+ oldFieldName+"</field><field name=\"PROPERTY_NAME\">", "<field name=\"CONTROL_NAME\">"+ newFieldName+"</field><field name=\"PROPERTY_NAME\">");
        window['globle'].xmlVal = this.replaceAllMatches(window['globle'].xmlVal, "<field name=\"CONTROL_NAME\">"+ oldFieldName+"</field></block>", "<field name=\"CONTROL_NAME\">"+ newFieldName+"</field></block>");
      }
    },
    replaceDataFieldNameInCodeEditor(controls, oldFieldName, newFieldName) {
      if(!controls) {
        controls = this.getAllControls();
      }

      //Replace in controls events code editor
      controls.forEach((control) => {
        if(control.properties && control.properties.Events) {
          for(let event in control.properties.Events) {
            let eventDetail = control.properties.Events[event];
            if(event != 'Name' && event != 'forceToDisabled' && eventDetail.selectedValue) {
              eventDetail.selectedValue = this.replaceAllMatches(eventDetail.selectedValue, "PropValueByDataFieldName('"+ oldFieldName +"'", "PropValueByDataFieldName('"+ newFieldName +"'");
              eventDetail.selectedValue = this.replaceAllMatches(eventDetail.selectedValue, "'DateDataFieldName###"+ oldFieldName +"###'", "'DateDataFieldName###"+ newFieldName +"###'");
              eventDetail.selectedValue = this.replaceAllMatches(eventDetail.selectedValue, "addOrSubtractDate('"+ oldFieldName +"'", "addOrSubtractDate('"+ newFieldName +"'");
              eventDetail.selectedValue = this.replaceAllMatches(eventDetail.selectedValue, "setAutoNumbering('"+ oldFieldName +"'", "setAutoNumbering('"+ newFieldName +"'");
              eventDetail.xmlValue = this.replaceAllMatches(eventDetail.xmlValue, "<field name=\"AUTO_NUMBER_FIELD\">"+ oldFieldName+"</field>", "<field name=\"AUTO_NUMBER_FIELD\">"+ newFieldName+"</field>");
              eventDetail.xmlValue = this.replaceAllMatches(eventDetail.xmlValue, "<field name=\"CONTROL_NAME\">"+ oldFieldName+"</field></block>", "<field name=\"CONTROL_NAME\">"+ newFieldName+"</field></block>");
              eventDetail.xmlValue = this.replaceAllMatches(eventDetail.xmlValue, "<field name=\"CONTROL_NAME\">"+ oldFieldName+"</field><value name=\"PROPERTY_VALUE_INPUT\">", "<field name=\"CONTROL_NAME\">"+ newFieldName+"</field><value name=\"PROPERTY_VALUE_INPUT\">");
              eventDetail.xmlValue = this.replaceAllMatches(eventDetail.xmlValue, "<field name=\"CONTROL_NAME\">"+ oldFieldName+"</field><field name=\"PROPERTY_VALUE\">", "<field name=\"CONTROL_NAME\">"+ newFieldName+"</field><field name=\"PROPERTY_VALUE\">");
              eventDetail.xmlValue = this.replaceAllMatches(eventDetail.xmlValue, "<field name=\"DATE1\">"+ oldFieldName+"</field>", "<field name=\"DATE1\">"+ newFieldName+"</field>");
              eventDetail.xmlValue = this.replaceAllMatches(eventDetail.xmlValue, "<field name=\"DATE2\">"+ oldFieldName+"</field>", "<field name=\"DATE2\">"+ newFieldName+"</field>");
              eventDetail.xmlValue = this.replaceAllMatches(eventDetail.xmlValue, "<field name=\"CONTROL_NAME\">"+ oldFieldName+"</field><field name=\"OPERATOR\">", "<field name=\"CONTROL_NAME\">"+ newFieldName+"</field><field name=\"OPERATOR\">");
            }
          }
        }
      });

      //Replace in Globle code editor
      if(window['globle'].scriptVal) {
        window['globle'].scriptVal = this.replaceAllMatches(window['globle'].scriptVal, "PropValueByDataFieldName('"+ oldFieldName +"'", "PropValueByDataFieldName('"+ newFieldName +"'");
        window['globle'].scriptVal = this.replaceAllMatches(window['globle'].scriptVal, "'DateDataFieldName###"+ oldFieldName +"###'", "'DateDataFieldName###"+ newFieldName +"###'");
        window['globle'].scriptVal = this.replaceAllMatches(window['globle'].scriptVal, "addOrSubtractDate('"+ oldFieldName +"'", "addOrSubtractDate('"+ newFieldName +"'");
        window['globle'].scriptVal = this.replaceAllMatches(window['globle'].scriptVal, "setAutoNumbering('"+ oldFieldName +"'", "setAutoNumbering('"+ newFieldName +"'");
        window['globle'].xmlVal = this.replaceAllMatches(window['globle'].xmlVal, "<field name=\"AUTO_NUMBER_FIELD\">"+ oldFieldName+"</field>", "<field name=\"AUTO_NUMBER_FIELD\">"+ newFieldName+"</field>");
        window['globle'].xmlVal = this.replaceAllMatches(window['globle'].xmlVal, "<field name=\"CONTROL_NAME\">"+ oldFieldName+"</field></block>", "<field name=\"CONTROL_NAME\">"+ newFieldName+"</field></block>");
        window['globle'].xmlVal = this.replaceAllMatches(window['globle'].xmlVal, "<field name=\"CONTROL_NAME\">"+ oldFieldName+"</field><value name=\"PROPERTY_VALUE_INPUT\">", "<field name=\"CONTROL_NAME\">"+ newFieldName+"</field><value name=\"PROPERTY_VALUE_INPUT\">");
        window['globle'].xmlVal = this.replaceAllMatches(window['globle'].xmlVal, "<field name=\"CONTROL_NAME\">"+ oldFieldName+"</field><field name=\"PROPERTY_VALUE\">", "<field name=\"CONTROL_NAME\">"+ newFieldName+"</field><field name=\"PROPERTY_VALUE\">");
        window['globle'].xmlVal = this.replaceAllMatches(window['globle'].xmlVal, "<field name=\"DATE1\">"+ oldFieldName+"</field>", "<field name=\"DATE1\">"+ newFieldName+"</field>");
        window['globle'].xmlVal = this.replaceAllMatches(window['globle'].xmlVal, "<field name=\"DATE2\">"+ oldFieldName+"</field>", "<field name=\"DATE2\">"+ newFieldName+"</field>");
        window['globle'].xmlVal = this.replaceAllMatches(window['globle'].xmlVal, "<field name=\"CONTROL_NAME\">"+ oldFieldName+"</field><field name=\"OPERATOR\">", "<field name=\"CONTROL_NAME\">"+ newFieldName+"</field><field name=\"OPERATOR\">");
      }
    },
    getNumberFieldNamesunderRepeatingTbl(totalItems,totalNumOptionsinRepeatingTable,parentNodeId){
      let fieldNames = [];
      let selectedItems = [];
      if(!totalItems) {
        totalItems = [];
      }

      if(!totalNumOptionsinRepeatingTable)
      totalNumOptionsinRepeatingTable = [] ;

      let selectedType = [];
      let selectedParent = [];
      if(!totalItems.length){
        totalItems = this.getAllControls();
      }
      
      for (let totalItem = 0; totalItem<totalItems.length; totalItem++) {
        if(totalItems[totalItem].type.toLowerCase() == "repeatingtable"){
          selectedItems = totalItems[totalItem].data[0];
          for(let j=0;j<selectedItems.length;j++){
            var selectedcolumn = selectedItems[j].elems[0];
            this.getAllchildNumberFieldNames(selectedcolumn,totalNumOptionsinRepeatingTable,parentNodeId)
          }
        }
       }

      if (totalNumOptionsinRepeatingTable.length) {
        for (let i = 0; i < totalNumOptionsinRepeatingTable.length; i++) {
          let fieldName = totalNumOptionsinRepeatingTable[i].properties.Basic && totalNumOptionsinRepeatingTable[i].properties.Basic['Field Name'].selectedValue;
          if(totalNumOptionsinRepeatingTable[i].type.toLowerCase() == "textbox")
          selectedType.push(totalNumOptionsinRepeatingTable[i].properties.Basic.Validate.selectedValue)
          else
          selectedType.push(null);
          
          if(totalNumOptionsinRepeatingTable[i].parent && totalNumOptionsinRepeatingTable[i].parent == "repeating-table" && (totalNumOptionsinRepeatingTable[i].type.toLowerCase() == "textbox" || totalNumOptionsinRepeatingTable[i].type.toLowerCase() == "display field") && !parentNodeId)
          selectedParent.push("underRT")
          else
          selectedParent.push("outsideRT");


          fieldName && fieldNames.indexOf(fieldName) == -1 && fieldNames.push(fieldName);
        }
      }
      return fieldNames.map(function (val,key) { return { key: val, value: val, type:selectedType[key], parent:selectedParent[key] } });
    },
    getAllchildNumberFieldNames(selectedcolumn,totalNumOptionsinRepeatingTable,parentNodeId){
      for(var k=0;k<selectedcolumn.length;k++){
        if(((selectedcolumn[k].type.toLowerCase() == "textbox" &&
        selectedcolumn[k].properties.Basic.Validate.selectedValue != "" && 
        (selectedcolumn[k].properties.Basic.Validate.selectedValue == "Integer" || 
        selectedcolumn[k].properties.Basic.Validate.selectedValue == "Decimal")) || 
        selectedcolumn[k].type.toLowerCase() == "display field" && !selectedcolumn[k].properties.Basic.Label.isSelected) && 
        (!parentNodeId || (parentNodeId && selectedcolumn[k].properties.Basic.parentNode.id == parentNodeId)))
        {
          totalNumOptionsinRepeatingTable.push(selectedcolumn[k]);
        }
        else if(selectedcolumn[k].type.toLowerCase() == "repeatingtable"){
          this.getNumberFieldNamesunderRepeatingTbl(selectedcolumn,totalNumOptionsinRepeatingTable,parentNodeId)
        }
     }
    },

    isValidXMLTagName(tag) {
      var t = !/^[xX][mM][lL]*/.test(tag);
      t = t && /^[a-zA-Z_]*/.test(tag);
      t = t && /^[a-zA-Z_]+[a-zA-Z0-9_]*$/.test(tag);
      t = t && tag.indexOf('___') == -1;
      return t;
    },

    /**
     * @brief      check for the valid text.
     * @return     boolena based on entered text valid or not.
     */
    isValidString(value) {
      var SCRIPT_REGEX = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
      value = value.replace(/\r/g, " ").replace(/\n/g, " ").toLowerCase();
      value = value.replace(/\/\*.*?\*\//g, '') // remove all the coomented code.
      // value = value.replace(SCRIPT_REGEX, "");
      let isValidString = true;
      if (value) {
          for (let i = 0; i < value.length; i++) {
              if (value.charCodeAt(i) < 32) {
                  isValidString = false;
                  break;
              }
          }
          let invalidStringArray = ['javascript:', '<script', '</script>', 'vbscript:',
              'livescript:', '<img', 'onload=', '<input', '<select', '<textarea', '<form', '<head', '<body', '<html', 'datasrc=', '<iframe', 'text/javascript',
              'eval(', 'expression(', 'url(', '&#', '&{[', 'document.cookie', 'window.location', 'window.open(', 'alert=', 'alert(', 'alert`', 'onclick=', 'prompt=', 'prompt`', 'prompt(',
              'oncopy=', 'oncut=', 'onpaste=', 'ondbllclick=', 'onmouseover=', 'onmousedown=', 'onmouseenter=', 'onmouseleave=', 'onmousemove=', 'onmouseout=', 'onmouseup=', 'window.replace',
              'onscroll=', 'ontouchcancel=', 'ontouchend=', 'ontouchmove=', 'ontouchstart=', 'confirm`', 'confirm(', 'confirm=', 'oninput=', 'location.', 'document.', 'angular.', '<meta', 'xss', '<noembed', '<noscript', '<xmp', 'window.name'];
          for (let i = 0; i < invalidStringArray.length; i++) {
              if (value.indexOf(invalidStringArray[i]) != -1) {
                  isValidString = false;
                  break;
              }
          }
      }
      return isValidString;
  },

    /**
     * @brief      Gets the supported languages.
     * @return     The supported languages.
     */
    getSupportedLanguages() {
      let self = this;
      return new Promise(function (resolve, reject) {
        $http({
          'url': (<any>window).properties.service.uri + ACTION_IDS.GET_ALL_LANGUAGES,
          'method': 'GET',
          'data': {},
          'headers': {
            'Content-Type': 'application/json;charset=UTF-8'
          },
          'withCredentials': true
        }).then(response => {
          if (response.data && response.data.entity && response.data.entity.length) {
            let data = JSON.parse(response.data.entity);
            self.supportedLanguages = data.jsonLocales;
          }
          resolve();
        }, (response) => {
          console.log(response);
          reject();
        });
      });
    },

    getGUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
          v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    },

    downloadZip(url, data) {
      let hiddenIFrameID = 'hiddenDownloader',
        iframe: HTMLIFrameElement = <HTMLIFrameElement>document.getElementById(hiddenIFrameID);
      if (iframe === null) {
        iframe = document.createElement('iframe');
        iframe.setAttribute('name', 'sample-iframe');
        iframe.id = hiddenIFrameID;
        iframe.style.display = 'none';
        document.body.appendChild(iframe);
      }
      
      var form = document.createElement('form');
      form.action = url;
      form.method = 'POST';
      form.target = "sample-iframe";
      
      for (var key in data) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = data[key];
        form.appendChild(input);
      }
      document.body.appendChild(form);
      form.submit();
      angular.element(form).remove();
    },

    formatDate(format, date) {
      if (!date) {
        return "";
      }

      var iFormat,
        dayNamesShort = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        monthNamesShort = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],

        // Check whether a format character is doubled
        lookAhead = function (match) {
          var matches = (iFormat + 1 < format.length && format.charAt(iFormat + 1) === match);
          if (matches) {
            iFormat++;
          }
          return matches;
        },
        // Format a number, with leading zero if necessary
        formatNumber = function (match, value, len) {
          var num = "" + value;
          if (lookAhead(match)) {
            while (num.length < len) {
              num = "0" + num;
            }
          }
          return num;
        },
        // Format a name, short or long as requested
        formatName = function (match, value, shortNames, longNames) {
          return (lookAhead(match) ? longNames[value] : shortNames[value]);
        },
        output = "",
        literal = false;

      if (date) {
        for (iFormat = 0; iFormat < format.length; iFormat++) {
          if (literal) {
            if (format.charAt(iFormat) === "'" && !lookAhead("'")) {
              literal = false;
            } else {
              output += format.charAt(iFormat);
            }
          } else {
            switch (format.charAt(iFormat)) {
              case "d":
                output += formatNumber("d", date.getDate(), 2);
                break;
              case "D":
                output += formatName("D", date.getDay(), dayNamesShort, dayNames);
                break;
              case "o":
                output += formatNumber("o",
                  Math.round((new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime() - new Date(date.getFullYear(), 0, 0).getTime()) / 86400000), 3);
                break;
              case "m":
                output += formatNumber("m", date.getMonth() + 1, 2);
                break;
              case "M":
                output += formatName("M", date.getMonth(), monthNamesShort, monthNames);
                break;
              case "y":
                output += (lookAhead("y") ? date.getFullYear() :
                  (date.getYear() % 100 < 10 ? "0" : "") + date.getYear() % 100);
                break;
              case "@":
                output += date.getTime();
                break;
              case "!":
                output += date.getTime() * 10000 + _ticksTo1970;
                break;
              case "'":
                if (lookAhead("'")) {
                  output += "'";
                } else {
                  literal = true;
                }
                break;
              default:
                output += format.charAt(iFormat);
            }
          }
        }
      }
      return output;
    },
    parseDate(format, value, settings) {
      if (format == null || value == null) {
        throw "Invalid arguments";
      }
    
      value = (typeof value === "object" ? value.toString() : value + "");
      if (value === "") {
        return null;
      }
    
      var iFormat, dim, extra,
        iValue = 0,
        shortYearCutoff = 26,
        dayNamesShort = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        monthNamesShort = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        year = -1,
        month = -1,
        day = -1,
        doy = -1,
        literal = false,
        date,
        // Check whether a format character is doubled
        lookAhead = function (match) {
          var matches = (iFormat + 1 < format.length && format.charAt(iFormat + 1) === match);
          if (matches) {
            iFormat++;
          }
          return matches;
        },
        // Extract a number from the string value
        getNumber = function (match) {
          var isDoubled = lookAhead(match),
            size = (match === "@" ? 14 : (match === "!" ? 20 :
              (match === "y" && isDoubled ? 4 : (match === "o" ? 3 : 2)))),
            minSize = (match === "y" ? size : 1),
            digits = new RegExp("^\\d{" + minSize + "," + size + "}"),
            num = value.substring(iValue).match(digits);
          if (!num) {
            throw "Missing number at position " + iValue;
          }
          iValue += num[0].length;
          return parseInt(num[0], 10);
        },
        // Extract a name from the string value and convert to an index
        getName = function (match, shortNames, longNames) {
          var index = -1,
            names = lookAhead(match) ? longNames : shortNames;
    
          names = names.map(function (v, k) {
            return [k, v];
          })
          names.sort(function (a, b) {
            return -(a[1].length - b[1].length);
          });
    
          for (var pair in names) {
            var name = names[pair][1];
            if (value.substr(iValue, name.length).toLowerCase() === name.toLowerCase()) {
              index = names[pair][0];
              iValue += name.length;
            }
          }
          if (index !== -1) {
            return index + 1;
          } else {
            throw "Unknown name at position " + iValue;
          }
        },
        // Confirm that a literal character matches the string value
        checkLiteral = function () {
          if (value.charAt(iValue) !== format.charAt(iFormat)) {
            throw "Unexpected literal at position " + iValue;
          }
          iValue++;
        };
    
      for (iFormat = 0; iFormat < format.length; iFormat++) {
        if (literal) {
          if (format.charAt(iFormat) === "'" && !lookAhead("'")) {
            literal = false;
          } else {
            checkLiteral();
          }
        } else {
          switch (format.charAt(iFormat)) {
            case "d":
              day = getNumber("d");
              break;
            case "D":
              getName("D", dayNamesShort, dayNames);
              break;
            case "o":
              doy = getNumber("o");
              break;
            case "m":
              month = getNumber("m");
              break;
            case "M":
              month = getName("M", monthNamesShort, monthNames);
              break;
            case "y":
              year = getNumber("y");
              break;
            case "@":
              date = new Date(getNumber("@"));
              year = date.getFullYear();
              month = date.getMonth() + 1;
              day = date.getDate();
              break;
            case "!":
              date = new Date((getNumber("!") - _ticksTo1970) / 10000);
              year = date.getFullYear();
              month = date.getMonth() + 1;
              day = date.getDate();
              break;
            case "'":
              if (lookAhead("'")) {
                checkLiteral();
              } else {
                literal = true;
              }
              break;
            default:
              checkLiteral();
          }
        }
      }
    
      if (iValue < value.length) {
        extra = value.substr(iValue);
        if (!/^\s+/.test(extra)) {
          throw "Extra/unparsed characters found in date: " + extra;
        }
      }
    
      if (year === -1) {
        year = new Date().getFullYear();
      } else if (year < 100) {
        year += new Date().getFullYear() - new Date().getFullYear() % 100 +
          (year <= shortYearCutoff ? 0 : -100);
      }
    
      var _daylightSavingAdjust = function (date) {
        if (!date) {
          return null;
        }
        date.setHours(date.getHours() > 12 ? date.getHours() + 2 : 0);
        return date;
      };
    
      var _getDaysInMonth = function (year, month) {
        return 32 - _daylightSavingAdjust(new Date(year, month, 32)).getDate();
      };
    
      if (doy > -1) {
        month = 1;
        day = doy;
        do {
          dim = _getDaysInMonth(year, month - 1);
          if (day <= dim) {
            break;
          }
          month++;
          day -= dim;
        } while (true);
      }
    
      date = _daylightSavingAdjust(new Date(year, month - 1, day));
      if (date.getFullYear() !== year || date.getMonth() + 1 !== month || date.getDate() !== day) {
        throw "Invalid date"; // E.g. 31/02/00
      }
      return date;
    },
    getDateFormat(format) {
      let datepickerFormat = {
        "dd-M-yy": 'dd-MMM-yyyy',
        "d M yy": 'd MMM yyyy',
        "dd.mm.yy": 'dd.MM.yyyy',
        "dd/mm/yy": 'dd/MM/yyyy',
        "d-M-yy": 'd-MMM-yyyy',
        "M d, yy": 'MMM d, yyyy',
        "yy-m-d": "yyyy-M-d",
        "dd M yy": "dd MMM yyyy",
        "yy/mm/dd": "yyyy/MM/dd",
        "dd-mm-yy": 'dd-MM-yyyy',
        "dd-mm-y": 'dd-MM-yy',
        "mm-dd-yy": 'MM-dd-yyyy',
        "mm-dd-y": 'MM-dd-yy',
        "dd/mm/y": 'dd/MM/yy'
      }

      if (format == 'default') {
        let langugageSpecificFormat = languageSpecificDateFormat[config.languageId] ? languageSpecificDateFormat[config.languageId] : "dd-M-yy";
        return datepickerFormat[langugageSpecificFormat] || 'dd-MMM-yyyy';
      } else {
        return datepickerFormat[format] || 'dd-MMM-yyyy';
      }
    },

    getNewDateFormat(format) {
      let datepickerFormat = {
        "dd-M-yy": 'DD-MMM-YYYY',
        "d M yy": 'D MMM YYYY',
        "dd.mm.yy": 'DD.MM.YYYY',
        "dd/mm/yy": 'DD/MM/YYYY',
        "d-M-yy": 'DD-MMM-YYYY',
        "M d, yy": 'MMM DD, YYYY',
        "yy-m-d": "YYYY-M-D",
        "dd M yy": "DD MMM YYYY",
        "yy/mm/dd": "YYYY/MM/DD",
        "dd-mm-yy": 'DD-MM-YYYY',
        "dd-mm-y": 'DD-MM-YY',
        "mm-dd-yy": 'MM-DD-YYYY',
        "mm-dd-y": 'MM-DD-YY',
        "dd/mm/y": 'DD/MM/YY'
      }

      if (format == 'default') {
        let langugageSpecificFormat = languageSpecificDateFormat[config.languageId] ? languageSpecificDateFormat[config.languageId] : "dd-M-yy";
        return datepickerFormat[langugageSpecificFormat] || 'DD-MMM-YYYY';
      } else {
        return datepickerFormat[format] || 'DD-MMM-YYYY';
      }
    },

    getLanguageSpecificDateFormat(format) {
      if (format == 'default') {
        return languageSpecificDateFormat[config.languageId] ? languageSpecificDateFormat[config.languageId] : "dd-M-yy";
      } else {
        return format;
      }
    },

    getDateObj(date) {
      return date ? new Date(date) : '';
    },

    addSubjectField(view) {
      let components = localStorage.get('components');
      let controls = components.items.filter(function (val) { return val.type == 'Textbox' });
      let Textbox;
      if (controls.length) {
        Textbox = angular.copy(controls[0]);
        _.set(Textbox.properties, "Basic['Field Name']['selectedValue']", 'ORI_FORMTITLE');
        _.set(Textbox.properties, "Basic['Field Name']['prevSelectedValue']", 'ORI_FORMTITLE');
        _.set(Textbox.properties, "Basic['Data Field Name']['selectedValue']", 'ORI_FORMTITLE');
        _.set(Textbox.properties, "Basic['Data Field Name']['prevSelectedValue']", 'ORI_FORMTITLE');
        _.set(Textbox.properties, "Basic['Label']['selectedValue']", 'Title');
        _.set(Textbox.properties, "Basic['Required']['selectedValue']", true);
        Textbox.uid = this.getGUID();
        Textbox.viewName = "ORI_VIEW";
      }
      view.controls.A.push(Textbox);
    },

    validate(list, valid) {
      let self = this;
      valid.defaulValuetMissing = [];
      if (list.length) {
        for (let i = 0; i < list.length; i++) {
          if (list[i].type == "Layout") {
            self.accessLayoutElements(list[i], function (elems) {
              valid = self.validate(elems, valid);
            });
          } else if (list[i].type == "Table") {
            self.accessTableElements(list[i], function (elems) {
              valid = self.validate(elems, valid);
            });
          } else if (list[i].type == "RepeatingTable") {
            self.accessRepeatingTableElements(list[i], function (elems) {
              valid = self.validate(elems, valid);
            });
          } else if (list[i].type == "Section") {
            self.accessSectionElements(list[i], function (elems) {
              valid = self.validate(elems, valid);
            });
          } else {
            let properties = list[i].properties;
            let required = _.get(properties, 'Basic.Required.selectedValue', false);
            let validPattern = _.get(properties, 'Basic.Validate.selectedValue', '0');
            let validationMap = {
              '7': 'Integer',
              '8': 'Decimal',
              '9': 'Email',
              '10': 'Alphanumeric',
              '11': 'Letters',
              '0': ''
            }
            validPattern = validationMap[validPattern] || validPattern;
            if (required || validPattern != "") {
              let defaultVal = '';
              switch (list[i].type) {
                /* case 'Text-Area': */
                case 'Textbox':
                  defaultVal = _.get(properties, 'Basic.Value.selectedValue', '');
                  required = false;
                  if (validPattern != "" && defaultVal) {
                    let regex: any = '';
                    switch (validPattern) {
                      case 'Numeric':
                        regex = /^-?\\d+(\\.\\d+)?$/;
                        break;
                      case 'Alphanumeric':
                        regex = /^[a-zA-Z0-9-\\._]+$/;
                        break;
                      case "Email":
                        regex = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
                        break;
                      case "Integer":
                        regex = /^(-)?\d+$/;
                        break;
                      case "Decimal":
                        regex = /^(-)?(?:\d*\.)?\d+$/;
                        break;
                      case "Letters":
                        regex = /^[a-zA-Z-\\._]+$/i;
                        break;
                    }
                    if (regex) {
                      let isValidInput = regex.test(defaultVal);
                      if (!isValidInput) {
                        valid.valid = false;
                        valid.notValidInput.push(_.get(properties, 'Basic.Label.selectedValue', ''));
                      }
                    }
                  }
                  break;
                case 'Checkbox':
                  var cList = properties['Data Source'].table.list;
                  for (var index = 0; index < cList.length; index++) {
                    if (cList[index].Default.name && cList[index].selectedValue.name != cList[index].Default.name) {
                      valid.valid = false;
                      valid.defaulValuetMissing.push(properties.Basic.Label.selectedValue);
                    }
                  }
                  let ds = _.get(properties, '["Data Source"].table.list', []);
                  ds.length && (defaultVal = ds.filter(function (val) { return val.selectedValue && val.selectedValue.name }));

                  break;
                case 'Dropdown':
                  var dList = properties['Data Source'].table.list;
                  for (var index = 0; index < dList.length; index++) {
                    if (dList[index].Default.name && _.get(list[i].properties, 'Basic.Value.selectedValue', '').indexOf(dList[index].Value.name) < 0) {
                      valid.valid = false;
                      valid.defaulValuetMissing.push(properties.Basic.Label.selectedValue);
                    }
                    defaultVal = _.get(properties, 'Basic.Value.selectedValue', []);
                  }

                  break;
                case 'MultiDropdown':
                  var dList = properties['Data Source'].table.list;
                  for (var index = 0; index < dList.length; index++) {
                    if (dList[index].Default.name && _.get(list[i].properties, 'Basic.Value.selectedValue', '').indexOf(dList[index].Value.name) < 0) {
                      valid.valid = false;
                      valid.defaulValuetMissing.push(properties.Basic.Label.selectedValue);
                    }
                    defaultVal = _.get(properties, 'Basic.Value.selectedValue', []);
                  }

                break;
                case 'Datepicker':
                  defaultVal = _.get(properties, 'Basic.Default.selectedValue', '');
                  required = false;
                  break;
                case 'Timepicker':
                    defaultVal = _.get(properties, 'Basic.Default.selectedValue', '');
                    required = false;
                    break;

                case 'Radio':
                  let dr = _.get(properties, '["Data Source"].table.list', []);
                  dr.length && (defaultVal = dr.filter(function (val) { return val.selectedValue && val.selectedValue.name }));
                  required = false;
                  break;

                case 'Map':
                  defaultVal = _.get(properties, 'Basic.Default.selectedValue', '');
                  required = false;
                  break;
              }

              if (required && !defaultVal.length) {
                valid.valid = false;
                valid.defaultMissing.push(_.get(properties, 'Basic.Label.selectedValue', ''));
              }
            }
          }
        }
      }
      return valid;
    },

    getControlByFieldName(fieldName) {
      let totalItems = this.getAllControls();
      let matchedControl = [];
      if (totalItems.length) {
        totalItems.some((control) => {
          if(control.properties && control.properties.Basic) {
            let controlFieldName = control.properties.Basic['Field Name'] && control.properties.Basic['Field Name'].selectedValue;
            if(fieldName == controlFieldName && !control.copiedFrom && !control.pasteAsCalculatedFrom) {
              matchedControl = control;
              return true;
            }
          }
        });
      }

      return matchedControl;
    },

    getReadOnlyControls(fieldName) {
      let totalItems = this.getAllControls();
      let readOnlyControls = [];
      if (totalItems.length) {
        totalItems.forEach((control) => {
          if(control.properties && control.properties.Basic) {
            let controlFieldName = control.properties.Basic['Field Name'] && control.properties.Basic['Field Name'].selectedValue;
            if(fieldName == controlFieldName && control.copiedFrom) {
              readOnlyControls.push(control);
            }
          }
        });
      }

      return readOnlyControls;
    },
	
    markAllPropertiesAsDisabled(properties) {
      for(let key in properties) {
        properties[key].forceToDisabled = true;
      }
    },
    
    refreshReadOnlyControlsPropeties(fieldName) {
      let self = this;

      let allReadOnlyControls = self.getReadOnlyControls(fieldName);
      if(!allReadOnlyControls.length) {
        return;
      }

      let originalControl = self.getControlByFieldName(fieldName);
      allReadOnlyControls.forEach((control) => {
        self.markAllPropertiesAsReadonly(control, originalControl ? originalControl.properties : {});
      });
    },

    markAllPropertiesAsReadonly(control, properties) {
      let self = this;
      if(!properties) {
        properties = {};
      }
      if(control.type == "Table" || control.type == "Layout" || control.type == "RepeatingTable") {
        for(let key in properties) {
          let subProperties = angular.copy(properties[key]);
          if (key == "Events") {
            for(let event in subProperties) {
              if(event != 'Name' && event != 'forceToDisabled') {
                subProperties[event].selectedValueReadonly = subProperties[event].selectedValueReadonly || subProperties[event].selectedValue;
                subProperties[event].selectedValue = '';
              }
            }
            control.properties[key] = subProperties;
          }else if(key == "Basic") {
            if(subProperties.hasOwnProperty('Insert_Button_Text')) {
              _.set(subProperties, "['Insert_Button_Text'].hidden", true);
            }
            _.set(subProperties, "['Field Name'].disable", true);
            if (control.type == "RepeatingTable") {
              _.set(subProperties, "['Data Field Name'].disable", true);
            }
            control.properties[key] = subProperties;
          }else if (key == 'Display' && subProperties.hasOwnProperty('Fit-to-Screen')) {
            _.set(control.properties, "Display['Fit-to-Screen'].selectedValue", subProperties['Fit-to-Screen'].selectedValue);
          }
        }
        _.set(control.properties, "Display.Hidden.hidden", true);
        
        control.propMigrated = true;
        return;
      }

      for(let key in properties) {
        let subProperties = angular.copy(properties[key]);
        if (key == "Events") {
          for(let event in subProperties) {
            if(event != 'Name' && event != 'forceToDisabled') {
              subProperties[event].selectedValueReadonly = subProperties[event].selectedValueReadonly || subProperties[event].selectedValue;
              subProperties[event].selectedValue = '';
            }
          }
        }else if(key == "Basic" && subProperties.hasOwnProperty('Insert_Button_Text')) {
          _.set(subProperties, "['Insert_Button_Text'].hidden", true);
        }else if(key == "Display" && subProperties.hasOwnProperty('Read-only')) {
          _.set(subProperties, "['Read-only'].selectedValue", true);
        }else if(key == "Data Source" && subProperties.hasOwnProperty('table')) {
          _.set(subProperties, "table.hideRemovebtn", true);
        }

        control.properties[key] = subProperties;
      }

      self.markAllPropertiesAsDisabled(control.properties);
      control.propMigrated = true;
    },

    getLanguageSpecificViewName(viewName) {
      if (!this.viewNames) {
        return viewName;
      }
      let viewDetail = this.viewNames.filter(function (value) { return value.name == viewName });
      if (viewDetail.length) {
        return viewDetail[0].value;
      }
      return viewName;
    },

    finddeep(items, attrs) {

      function match(value) {
        try {
          for (var key in attrs) {
            if (!_.isUndefined(value)) {
              if (attrs[key] !== value[key]) {
                return false;
              }
            }
          }

          return true;
        } catch (err) {

        }
      }

      function traverse(value) {
        var result;

        _.forEach(value, function (val) {
          if (match(val)) {
            result = val;
            return false;
          }

          if (_.isObject(val) || _.isArray(val)) {
            result = traverse(val);
          }

          if (result) {
            return false;
          }
        });

        return result;
      }

      return traverse(items);

    },

    openLoginModal() {
      if (loginModal) {
        return;
      }
      // Return when SSO login
      if($rootScope.USP && $rootScope.USP.loginMethodType === 2) {
        return;
      }
      $timeout(() => {
        loginModal = $uibModal.open({
          component: 'login',
          keyboard: false,
          backdrop: 'static',
          windowClass: 'login-modal',
          backdropClass: 'login-backdrop'
        });
        loginModal.closed.then(function () {
          loginModal = null;
        })
      }, 100);
    },

    setsessionTimoutTimer(duration) {
      // Return when SSO login
      if($rootScope.USP && $rootScope.USP.loginMethodType === 2) {
        return;
      }
      timer && $timeout.cancel(timer);
      if ($rootScope.USP && $rootScope.USP.sessionTimeoutDuration) {
        if (duration && parseFloat(duration) > 0) {
          timer = $timeout(Util.checkSessionTimeout, parseFloat(duration) * 60000);
        } else {
          timer = $timeout(Util.checkSessionTimeout, parseFloat($rootScope.USP.sessionTimeoutDuration) * 60000);
        }
      }
    },
    hasDuplicates(arr) {
      return new Set(arr).size !== arr.length;
    },

    checkSessionTimeout() {
      $http({
        'url': (<any>window).properties.service.commonApiUrl + ACTION_IDS.GET_SESSION_TIMEOUT_DETAILS,
        'method': 'GET',
        'data': {},
        'headers': {
          'Content-Type': 'application/json;charset=UTF-8'
        },
        'withCredentials': true
      }).then(response => {
        window.localStorage.setItem('sessionState', !response.data.timeout ? 'Active' : 'Inactive');
        window.top && window.top.opener && window.top.opener.setSessionState && window.top.opener.setSessionState('sessionState', !response.data.timeout ? 'Active' : 'Inactive');
        if (response.data.timeout) {
          Util.openLoginModal();
        } else {
          Util.setsessionTimoutTimer(parseFloat(response.data.remainingMilliSecond) / 60000);
        }
      }, (response) => {
        if (!navigator.onLine) {
          Util.setsessionTimoutTimer(parseFloat('10000') / 60000);
        }
      });
    },
    
    getAllAPIConnections(formId, instanceGroupId, projectId) {
      let queryParams = '';
      if (instanceGroupId && projectId) {
        queryParams = '?instanceGroupId=' + instanceGroupId + '&projectId=' + projectId;
      } else {
        queryParams = '?formId=' + formId;
      }
      return new Promise(function (resolve, reject) {
        $http({
          'url': (<any>window).properties.service.uri + ACTION_IDS.GET_API_CONNECTION_LIST + queryParams,
          'method': 'GET',
          'withCredentials': true,
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        }).then(response => {
          resolve(response);
        }, (response) => {
          resolve(response);
        });
      });
    },
    
    getProjectList() {
      return new Promise(function (resolve, reject) {
        $http({
          'url': (<any>window).properties.service.commonApiUrl.replace('/commonapi/', '/adoddle/') + ACTION_IDS.GET_ALL_PROJECTS,//https://adoddleqaak.asite.com/adoddle/projects
          'method': 'POST',
          data :$httpParamSerializer( { action_id : 1001, recordBatchSize: -1}),
          'withCredentials': true,
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        }).then(response => {
          let projects = [];
          if(response.data.totalDocs > 0){
            projects = response.data.data;
          }
          resolve(projects);
        }, (response) => {
          resolve(response);
        });
      });
    },

    getAppBuilderID: function(projectId) {
      return new Promise(function (resolve, reject) {
        $http({
          'url': (<any>window).properties.service.commonApiUrl.replace('/commonapi/', '/adoddle/') + 'projects',
          'method': 'POST',
          'withCredentials': true,
          data :$httpParamSerializer( { projectId : projectId, action_id : 1018, dcId : 1, currentPageNo : 1, recordStartFrom : 0, recordBatchSize : 100, iFormACLFlag : 2}),
          // data: {project_name : projectName // projectId: projectID, action_id: action_id, dcId: dcId, currentPageNo: currentPageNo, recordStartFrom: recordStartFrom, recordBatchSize: recordBatchSize, iFormACLFlag: iFormACLFlag},
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        }).then(response => {
          var filterData = response.data.data;
          filterData = filterData.filter(item => !(item.is_active == false));
          resolve(filterData);
      }, (response) => {
          console.log("error");
        });
      });
    },

    getDestinationFieldName: function(projectId, appBuildercode) {
      appBuildercode = encodeURIComponent(appBuildercode);
      return new Promise(function (resolve, reject) {
        $http({
          'url': (<any>window).properties.service.commonApiUrl+ 'form' + '/getFormTemplate' + '?projectId=' + projectId + '&appBuilderCode=' + appBuildercode,
          'method': 'POST',
          'withCredentials': true,
          data :$httpParamSerializer( { projectId : projectId, appBuilderCode : appBuildercode}),
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        }).then(response => {
          var filterData = response.data.fieldJson;
          resolve(filterData);
      }, (response) => {
          console.log("error");
        });
      });
    },

    setBlocklyBlock:function(valObJ){
      window.localStorage.removeItem('domXml');
      let domXml = valObJ.xmlVal;
      let xmlDoc = $($.parseXML(domXml));
      let domXmlData  = xmlDoc[0].children[0].innerHTML;
      window.localStorage.setItem("domXml", domXmlData);
    },
  
    getBlocklyBlock:function(){
      let blockfromstorage = window.localStorage.getItem("domXml");
      let xmlData = `<xml xmlns="https://Developers.google.com/blockly/xml">${blockfromstorage}</xml>`;
      return xmlData;
    },

    updateCalculatedControls(CalculatedCtrl, selectedItem, currentFieldName, flag) {
      CalculatedCtrl.forEach((control) => {
        this.updateCalculatedFieldProperties(control, selectedItem, currentFieldName, flag);
      });
    },

    updateCalculatedFieldProperties(control, referencedItem, currentFieldName, flag) {
      if (!control) {
        return;
      }

      const controlType = referencedItem.type;
      flag === "FieldName" && control.pasteAsCalculatedFrom && (control.pasteAsCalculatedFrom = currentFieldName);

      if (controlType == 'Attachment' || controlType == 'Image' || controlType == 'Label' || controlType == 'Button' || controlType == 'SiteLocationButton' || controlType == 'Hyperlink' || controlType == 'InlineAssocFiles' || controlType == 'InlineAssocApps' || controlType == 'ViewAssociations' || controlType === 'Layout' || controlType === 'Table') {
        return;
      }

      if (flag === 'DataFieldName' && control.type === "RepeatingTable") {
        let rptFieldName = _.get(referencedItem, 'properties.Basic["Field Name"].selectedValue');
        _.set(control, 'properties.Basic.Value.selectedValue', `{{${rptFieldName}}}`);
        _.set(control, 'properties.Basic.DSName.selectedValue', rptFieldName)
        control.derivedFromFieldName = rptFieldName;
        _.set(control, 'properties.Basic["Data Field Name"].selectedValue', currentFieldName);
        _.set(control, 'properties.Basic["Data Field Name"].prevSelectedValue', currentFieldName);
        return;
      }

      if (flag === 'DataFieldName') {
        control.derivedFromFieldName = currentFieldName;
        return;
      }

      if (controlType === 'Datepicker' && flag === 'FieldName') {
        _.set(control, 'properties.Basic.RefFieldName', currentFieldName);
        return;
      }

      // update repeating table properties if fieldname is changed
      if (controlType === 'RepeatingTable' && flag === 'FieldName') {
        _.set(control, 'properties.Basic.Value.selectedValue', `{{${currentFieldName}}}`);
        _.set(control, 'properties.Basic.DSName.selectedValue', currentFieldName);
        control.derivedFromFieldName = currentFieldName;
        return;
      }

      // for calculated Value control
      if (controlType === "Display field" && flag === "FieldName") {
        let DSName = _.get(referencedItem, 'properties.Basic.DSName.selectedValue');
        _.set(control, 'properties.Basic.Value.selectedValue', `{{${currentFieldName}}}`);
        DSName && _.set(control, 'properties.Basic.DSName.selectedValue', DSName);
        control.derivedFromFieldName = currentFieldName;
      }
    },

    getDocColumnList() {
      let self = this;
      let projectId = _.get(config, 'formDetail.id.projectId', '');
      return new Promise(function (resolve, reject) {
        $http({
          'url': (<any>window).properties.service.commonApiUrl.replace('/commonapi/', '/adoddle/') + 'configcontroller',
          'method': 'POST',
        data :$httpParamSerializer( { action_id : 1722, listingType: 184, projectId: projectId}),
          'withCredentials': true,
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        }).then(response => {
          console.log('doc', response);
          self.docColData = response.data || [];
          resolve(response);
        }, (response) => {
          resolve(response);
        });
      });
    },
  
    getAppColumnList() {
      let self = this;
      return new Promise(function (resolve, reject) {
        $http({
          'url': (<any>window).properties.service.commonApiUrl.replace('/commonapi/', '/adoddle/') + 'configcontroller',
          'method': 'POST',
          data :$httpParamSerializer( { action_id : 1722, listingType: 185}),
          'withCredentials': true,
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        }).then(response => {
          console.log('app', response);
          self.appColData = response.data || [];
          resolve(response);
        }, (response) => {
          resolve(response);
        });
      });
    },

    getControlsByDataFieldName(dataFieldName) {
      let views = localStorage.get('views');;
      if (!views) {
        return;
      }
      let controls = this.getAllControls();
      let controlList: any[] = [];
      controls.length && controls.forEach((control) => {
        if (!control.forceToReadOnly && !control.readOnly && control.properties.Basic && control.properties.Basic['Data Field Name'] && control.properties.Basic['Data Field Name'].selectedValue == dataFieldName) {
          controlList.push(control);
        }
      });
      return controlList;
    }
  };

  (<any>window).openLoginModal = Util.openLoginModal;
  (<any>window).setsessionTimoutTimer = Util.setsessionTimoutTimer;

  return Util;
}



// WEBPACK FOOTER //
// ./client/components/util/util.service.ts